import { createSlice } from "@reduxjs/toolkit";

export const emailSettingSlice = createSlice({
  name: "emailSetting",
  initialState: {
    getEmailSettingResult: false,
    addEmailSettingResult: false,
    addEmailSettingLoading: false,
  },
  reducers: {
    emailSettingReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_EMAILSETTING":
          return {
            ...state,
            getEmailSettingResult: payload.data,
          };
        case "ADD_EMAILSETTING":
          return {
            ...state,
            addEmailSettingResult: payload.data,
            addEmailSettingLoading: payload.loading,
          };
        default:
          return state;
      }
    },
  },
});

export const { emailSettingReducers } = emailSettingSlice.actions;

export default emailSettingSlice.reducer;
